/**
 * D4 — the reasons a customer can REPORT a listing for, as the report dialog
 * offers them. DERIVED from `listing.v1.ListingReportReason` (a new proto
 * reason joins the list by existing) with `UNSPECIFIED` removed — the server
 * refuses it, so the dialog's value space excludes it. Labels are the
 * `proto-enums/<package>.yaml` rows, never re-spelled. Here, one layer below the
 * component, because a component may not import a proto enum (Rule #1).
 */
import type { StatedListingReportReasonName } from '@/shared/lib/types/listing';
import { type ProtoEnumLocale } from '@letsgethome/lib/proto-enums/common/labels_gen';
import { listingReportReasonLabel } from '@letsgethome/lib/proto-enums/listing/labels_gen';
import { protoEnumNames, protoEnumOptions } from '@letsgethome/lib/proto-enums/options';
import { ListingReportReason } from '@letsgethome/proto/listing/v1/listing_report_reason_pb';

const STATED_REASON_NAMES: readonly StatedListingReportReasonName[] = protoEnumNames(
  ListingReportReason
).filter((name): name is StatedListingReportReasonName => name !== 'UNSPECIFIED');

/** The dialog's reason options, in proto order, at `locale`. */
export function listingReportReasonOptions(locale: ProtoEnumLocale) {
  return protoEnumOptions(ListingReportReason, listingReportReasonLabel, locale, {
    names: STATED_REASON_NAMES,
  });
}
